import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsVintageMac: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.43 3.05h1.52v24.38h-1.52ZM25.9 1.52h1.53v1.53H25.9ZM4.57 27.43v1.52h1.52v1.53h1.53v-1.53h16.76v1.53h1.52v-1.53h1.53v-1.52zM24.38 4.57h1.52v13.72h-1.52ZM7.62 30.48h16.76V32H7.62Zm10.66-7.62h6.1v1.52h-6.1ZM7.62 18.29h16.76v1.52H7.62Zm9.14-3.05h4.57v-1.53h1.52V9.14h-1.52V7.62h-4.57v1.52h-1.52v1.53h1.52v1.52h-1.52v1.52h1.52Zm1.52-6.1h1.53v1.53h-1.53Zm-6.09 1.53h1.52v1.52h-1.52Zm-3.05 0h1.52v1.52H9.14ZM7.62 3.05h16.76v1.52H7.62Zm0 19.81h1.52v1.52H7.62ZM6.09 0H25.9v1.52H6.09Zm0 4.57h1.53v13.72H6.09ZM4.57 1.52h1.52v1.53H4.57ZM3.05 3.05h1.52v24.38H3.05Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsVintageMac
